(() => {
  const TIER_SLOT_COUNT = { 1: 1, 2: 2, 3: 3 };

  class BundlePicker {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.config = BundlePicker.readConfig(this.sectionId);
      this.slotsEl = root.querySelector('[data-bundle-slots]');
      this.errorEl = root.querySelector('[data-bundle-error]');
      this.submitButton = root.querySelector('[data-bundle-add-to-cart]');
      this.submitLabelEl = root.querySelector('[data-bundle-submit-label]');
      this.defaultSubmitLabel = this.submitLabelEl.textContent;

      root.querySelectorAll('input[name^="bundle-tier-"]').forEach((input) => {
        input.addEventListener('change', () => this.renderSlots());
      });

      this.submitButton.addEventListener('click', () => this.addToCart());

      this.renderSlots();
    }

    static readConfig(sectionId) {
      const el = document.querySelector(
        `script[data-bundle-picker-config="${sectionId}"]`,
      );
      return JSON.parse(el.textContent);
    }

    get selectedTier() {
      const checked = this.root.querySelector('input[name^="bundle-tier-"]:checked');
      return Number(checked ? checked.value : 1);
    }

    availableVariants() {
      return this.config.variants.filter((variant) => variant.available);
    }

    renderSlots() {
      const slotCount = TIER_SLOT_COUNT[this.selectedTier] || 1;
      const available = this.availableVariants();
      const previousValues = Array.from(
        this.slotsEl.querySelectorAll('select'),
      ).map((select) => select.value);

      this.slotsEl.innerHTML = '';

      for (let i = 0; i < slotCount; i += 1) {
        const wrapper = document.createElement('div');
        wrapper.className = 'bundle-picker__slot';

        const label = document.createElement('label');
        label.className = 'bundle-picker__slot-label';
        label.textContent = `${this.config.labels.colorSlot} #${i + 1}`;
        label.setAttribute('for', `bundle-slot-${this.sectionId}-${i}`);

        const select = document.createElement('select');
        select.id = `bundle-slot-${this.sectionId}-${i}`;
        select.className = 'bundle-picker__slot-select';
        select.dataset.bundleSlotSelect = '';

        available.forEach((variant) => {
          const option = document.createElement('option');
          option.value = variant.id;
          option.textContent = variant.optionColor || variant.title;
          select.appendChild(option);
        });

        if (previousValues[i] && available.some((v) => String(v.id) === previousValues[i])) {
          select.value = previousValues[i];
        } else if (available[i % available.length]) {
          select.value = available[i % available.length].id;
        }

        wrapper.appendChild(label);
        wrapper.appendChild(select);
        this.slotsEl.appendChild(wrapper);
      }
    }

    selectedItems() {
      const selects = Array.from(this.slotsEl.querySelectorAll('[data-bundle-slot-select]'));
      const quantitiesByVariantId = new Map();

      selects.forEach((select) => {
        const id = Number(select.value);
        quantitiesByVariantId.set(id, (quantitiesByVariantId.get(id) || 0) + 1);
      });

      return Array.from(quantitiesByVariantId, ([id, quantity]) => ({ id, quantity }));
    }

    showError(message) {
      this.errorEl.textContent = message;
      this.errorEl.hidden = false;
    }

    clearError() {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
    }

    setLoading(isLoading) {
      this.submitButton.disabled = isLoading;
      this.submitLabelEl.textContent = isLoading
        ? this.config.labels.adding
        : this.defaultSubmitLabel;
    }

    cartDrawerSectionsToRender() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        return cartDrawer.getSectionsToRender().map((section) => section.id);
      }
      return ['cart-drawer', 'cart-icon-bubble'];
    }

    async addToCart() {
      this.clearError();
      const items = this.selectedItems();

      if (!items.length) {
        this.showError(this.config.labels.unavailable);
        return;
      }

      this.setLoading(true);

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items,
            sections: this.cartDrawerSectionsToRender(),
            sections_url: window.location.pathname,
          }),
        });

        const data = await response.json();

        if (!response.ok) {
          this.showError(data.description || this.config.labels.genericError);
          return;
        }

        this.openCartDrawer(data);
      } catch (error) {
        this.showError(this.config.labels.genericError);
      } finally {
        this.setLoading(false);
      }
    }

    openCartDrawer(addResponse) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(addResponse);
        return;
      }

      document.dispatchEvent(
        new CustomEvent('cart:updated', { bubbles: true, detail: { cart: addResponse } }),
      );
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    }
  }

  document.querySelectorAll('[data-bundle-picker]').forEach((root) => new BundlePicker(root));
})();
